import { render, staticRenderFns } from "./PDFPage.vue?vue&type=template&id=0b3445e8&scoped=true&"
import script from "./PDFPage.vue?vue&type=script&lang=js&"
export * from "./PDFPage.vue?vue&type=script&lang=js&"
import style0 from "./PDFPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PDFPage.vue?vue&type=style&index=1&id=0b3445e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3445e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
